import React from 'react';
import type { PortalTheme, PortalSection, SidebarButtonConfig } from '../../types/portal-base';

// SVG Icons for the sidebar buttons
const UserIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);

const KeyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
  </svg>
);

const DocumentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
  </svg>
);

interface PortalSidebarProps {
  theme: PortalTheme;
  activeSection: PortalSection;
  onSectionChange: (section: PortalSection) => void;
  buttons: SidebarButtonConfig[];
}

const PortalSidebar: React.FC<PortalSidebarProps> = ({
  theme,
  activeSection,
  onSectionChange,
  buttons
}) => {
  const sidebarClass = theme === 'admin' 
    ? 'integrated-admin-sidebar' 
    : 'integrated-portal-sidebar';

  const buttonBaseClass = theme === 'admin'
    ? 'admin-sidebar-button'
    : 'integrated-sidebar-button';

  const iconClass = theme === 'admin'
    ? 'admin-sidebar-button-icon'
    : 'integrated-sidebar-button-icon';

  const getIconComponent = (buttonId: string) => {
    switch (buttonId) {
      case 'login':
        return UserIcon;
      case 'reset':
      case 'forgot':
        return KeyIcon;
      case 'guide':
      case 'download':
        return DocumentIcon;
      default:
        return UserIcon;
    }
  };

  return (
    <div className={sidebarClass}>
      {buttons.map((button) => {
        const IconComponent = getIconComponent(button.id);
        const buttonClass = `${buttonBaseClass} ${buttonBaseClass}-${button.id} ${
          activeSection === button.section ? 'active' : ''
        }`;

        return (
          <button
            key={button.id}
            className={buttonClass}
            onClick={() => onSectionChange(button.section)}
            type="button"
          >
            <IconComponent className={iconClass} />
            <span>{button.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PortalSidebar;